import { createContext, useContext } from "react";

const RetargetingSegmentsContext = createContext();

export const useRetargetingSegmentsContext = () => useContext(RetargetingSegmentsContext);

export default RetargetingSegmentsContext;
